import type { UseAppEventShare } from '../app-event/useAppEventShare';
import DialogShare from '~/components/dialog/share/DialogShare.vue';

export const useShareExercise = (
  score: number,
  name: string,
  appEventShare?: UseAppEventShare
) => {
  const { share, isSupported: isShareSupported } = useShare();

  const { chapter } = inject(INJECT_CATEGORY_PAGE);

  const { t } = useI18n();

  const route = useRoute();

  const grade = computed(() => {
    return `${getScoreOn20(score)}/20`;
  });

  const shareText = computed(() => {
    return t('share.exercise.description', {
      name,
      grade: grade.value,
      url: url.value,
    });
  });

  const url = computed(() => {
    const baseUrl = `https://nomadeducation.onelink.me/1B9T?af_web_dp=https://app.nomadeducation.fr${route.fullPath}`;
    const chapterId = chapter.value ? chapter.value.id : null;
    if (chapterId) {
      return `${baseUrl}&deep_link_value=nomadeducation-nomadeducation://nomadeducation.fr/categories/${chapterId}/quiz`;
    } else {
      return baseUrl;
    }
  });

  const dialog = useDialogStore();

  const handleShare = () => {
    if (appEventShare) appEventShare.clicked();
    if (!isShareSupported.value) {
      dialog.open(DialogShare, {
        iconHeader: 'share',
        title: t('share.quiz.title'),
        label: '',
        shareText: shareText.value,
      });
    } else {
      share({
        text: shareText.value,
      });
    }
  };
  return {
    handleShare,
  };
};
